import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { FeedbackApiService } from '../../../../common/components/feedback-modal/feedback-api.service';
import { ToastService } from '../../../../common/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardFeedbackService {
  private readonly feedbackApiService = inject(FeedbackApiService);
  private readonly toastService = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  // Dashboard feedback modal state
  private readonly isDashboardFeedbackOpen$$ = new BehaviorSubject<boolean>(false);
  readonly isDashboardFeedbackOpen$ = this.isDashboardFeedbackOpen$$.asObservable();

  openDashboardFeedback(): void {
    this.isDashboardFeedbackOpen$$.next(true);
  }

  closeDashboardFeedback(): void {
    this.isDashboardFeedbackOpen$$.next(false);
  }

  submitFeedback(feedbackText: string, feedbackType: string): void {
    this.feedbackApiService
      .submitFeedback({
        feedbackType,
        feedbackText,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.closeDashboardFeedback();
          this.toastService.success('Thank you for your feedback!');
        },
        error: (err) => {
          console.error('Failed to submit feedback:', err);
          this.closeDashboardFeedback();
          this.toastService.success('Thanks for your feedback!');
        },
      });
  }
}
